import type { PriorityDto } from "@/spz-api/model";

export interface PriorityOption {
  value: string;
  label: string;
  variant: string;
  symbol: string;
}

export class PriorityMapper {
  static toOption(dto: PriorityDto): PriorityOption {
    return {
      value: dto.id,
      label: dto.labelKeyName,
      variant: dto.variant,
      symbol: dto.symbolKeyName,
    };
  }

  static toOptions(dtos: PriorityDto[]): PriorityOption[] {
    return dtos.map((dto) => PriorityMapper.toOption(dto));
  }
}
